const FEATURES = [
  {
    icon: 'ri-book-read-line',
    title: '海量漫画资源',
    desc: '收录超过30,000部韩漫、日漫、国漫，从热门新番到经典老漫一网打尽，满足各类读者的口味需求。',
  },
  {
    icon: 'ri-flashlight-line',
    title: '极速同步更新',
    desc: '编辑团队全天候监控连载动态，新章节发布后最快10分钟内完成同步，确保你不掉队。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '下拉式流畅阅读',
    desc: '专为移动端优化的阅读模式，无需翻页只需下滑即可连续阅读，加载迅速画面清晰。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全无广告',
    desc: '全站无恶意弹窗广告，绿色安全的阅读环境，让你专注于漫画阅读享受。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 px-4 md:px-6 bg-background-100 scroll-mt-[72px]">
      <div className="max-w-[1440px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900">平台特色</h2>
          <p className="text-foreground-500 text-sm mt-3">为什么800万读者选择土豪漫画网</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {FEATURES.map((feature) => (
            <div
              key={feature.title}
              className="bg-background-50 rounded-xl border border-background-200/70 p-6 text-center hover:border-primary-200 transition-all"
            >
              <div className="w-14 h-14 mx-auto mb-4 rounded-2xl bg-primary-100 flex items-center justify-center">
                <i className={`${feature.icon} text-2xl text-primary-500 w-7 h-7 flex items-center justify-center`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-900 mb-2">{feature.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{feature.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}